export { SmokecreenItem as default };

/**
* Smokecreen Item Entity
*
* A representation of a smokecreen address with a mapped structure from the API
*
* @author      Ruben Simões<ruben.r.simoes@meo.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.1.0
*/
class SmokecreenItem
{
  /**
   * Smokescreen email address
   *
   * @type {String}
   *
   * @since 7.1.0
   */
  address;

  /**
   * Smokescreen status
   *
   * @type {String} ENABLED | DISABLED | PENDING | DELETED
   *
   * @since 7.1.0
   */
  active;

  /**
   * Date of last modification
   *
   * @type {String}
   *
   * @since 7.1.0
   */
  date;
}